import React, { useState, useContext, useEffect } from "react";
import MapIR from "./MapIR";
import useAxios from "../../services/useAxios";
import CustomButton from "../kits/custom-button/CustomButton";
import { CustomInput, CustomTextArea } from "../kits/inputs/Input";
import axios from "axios";
import DeleteAddress from "./DeleteAddress";
import { mobileChecker } from "../../utilities/regexCheckers";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";

const AddressManage = ({
  setIsOpenDrawer,
  setHeight,
  setComponent,
  itemInfo,
  updateAddress,
}) => {
  function Edit() {
    const [titleData, setTitleData] = useState(itemInfo.title);
    const [mobileData, setMobileData] = useState(itemInfo.mobile);
    const [address, setAddress] = useState(itemInfo.address);
    const auth = useContext(AuthenticationContext);
    const [Nextstep, setNextstep] = useState(true);
    const [location, setLocation] = useState({
      lngLat: { lng: itemInfo.lang, lat: itemInfo.lat },
    });

    const { execute: EditAddressApi } = useAxios("api/Update_UsersAddress");
    async function EditAddressFunc(AddressData, TitleData, MobileData) {
      await EditAddressApi({
        conditions: `id/=/${itemInfo.id}`,
        keyvalues: `title,${TitleData}@@address,${AddressData}@@mobile,${MobileData}@@lang,${location.lngLat.lng},
      @@lat,${location.lngLat.lat}`,
      }).then((res) => {
        if (res.status == 1) {
          setIsOpenDrawer(false);
          auth.refreshAddresses();
        }
      });
    }
    return (
      <>
        <div className="text-start ">
          <p className="title-h3-b mr-b-16 mr-t-20">ویرایش آدرس</p>
        </div>
        <div className="pd-x-4 my-2">
          <MapIR
            location={location}
            height={138}
            setAddress={setAddress}
            setLocation={setLocation}
            setNextstep={setNextstep}
          />
        </div>
        <AllInputs
          address={address.split("&")[0]}
          mainAddress={address.split("&")[1]}
          TitleData={titleData}
          MobileData={mobileData}
          EditAddressFunc={EditAddressFunc}
          setHeight={setHeight}
          setComponent={setComponent}
          itemInfo={itemInfo}
          setIsOpenDrawer={setIsOpenDrawer}
          updateAddress={updateAddress}
        />
      </>
    );
  }

  return (
    <div className="">
      <Edit setComponent={setComponent} />
    </div>
  );
};

export default AddressManage;

const AllInputs = ({
  SetAddressData,
  SetTitleData,
  SetMobileData,
  address,
  TitleData,
  MobileData,
  setHeight,
  setComponent,
  itemInfo,
  setIsOpenDrawer,
  updateAddress,
  EditAddressFunc,
  mainAddress,
}) => {
  const [addressData, setAddressData] = useState(mainAddress);
  const [titleData, setTitleData] = useState(TitleData);
  const [mobileData, setMobileData] = useState(MobileData);
  const [addressError, setAddressError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const valid = () => {
    let error = [1, 1, 1];
    if (addressData == "" && address == "") {
      setAddressError(" آدرس را وارد کنید.");
      error[0] = 0;
    } else {
      setAddressError("");
      error[0] = 1;
    }
    if (titleData == "") {
      setTitleError("عنوان آدرس را وارد کنید.");
      error[1] = 0;
    } else {
      setTitleError("");
      error[1] = 1;
    }
    if (mobileData == "") {
      setMobileError(" شماره تماس را وارد کنید.");
      error[2] = 0;
    } else if (!mobileChecker(mobileData)) {
      setMobileError(" شماره تماس وارد شده صحیح نیست.");
      error[2] = 0;
    } else {
      setMobileError("");
      error[2] = 1;
    }
    return error;
  };

  var enToFaDigits = function (input) {
    if (input == undefined) return;
    var returnModel = "",
      symbolMap = {
        1: "۱",
        2: "۲",
        3: "۳",
        4: "۴",
        5: "۵",
        6: "۶",
        7: "۷",
        8: "۸",
        9: "۹",
        0: "۰",
      };
    input = input.toString();
    for (var i = 0; i < input.length; i++)
      if (symbolMap[input[i]]) returnModel += symbolMap[input[i]];
      else returnModel += input[i];
    return returnModel;
  };

  function toEnDigit(s) {
    return s.replace(
      /[\u0660-\u0669\u06f0-\u06f9]/g, // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
      function (a) {
        return a.charCodeAt(0) & 0xf;
      } // Remove the Unicode base(2) range that not match
    );
  }

  return (
    <>
      <div className="mr-t-32">
        <CustomTextArea
          title="نشانی"
          placeholder="میدان هفت‌تیر، زیر پل ناکجاآباد، کوچه مستانه، پلاک ۱۲۴۵"
          value={address.length > 0 ? address + "،" + addressData : addressData}
          onChange={(e) => {
            if (
              (!(e.target.value == address) || address.length == 0) &&
              e.target.value.split(address + "،").length != 1
            ) {
              setAddressData(e.target.value.replace(address + "،", ""));
            }
          }}
          messageText={addressError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={addressError.length === 0 ? "none" : "error"}
        />
        <CustomInput
          title="عنوان آدرس"
          placeholder="خونه هفت‌تیر"
          value={titleData}
          onChange={(e) => setTitleData(e.target.value)}
          messageText={titleError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={titleError.length === 0 ? "none" : "error"}
        />
        <CustomInput
          title="شماره تماس"
          placeholder="۰۹۳۰۵۶۷۱۲۳۴"
          value={mobileData}
          onChange={(e) => {
            setMobileData(toEnDigit(e.target.value));
          }}
          messageText={mobileError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={mobileError.length === 0 ? "none" : "error"}
          type="number"
        />
      </div>
      <div className="d-flex justify-content-between  w-100 pd-x-4 mr-b-20 mr-t-32">
        <CustomButton
          className="w-50"
          buttonStyle=""
          state="default"
          size="medium"
          onClick={() => {
            setHeight(178);
            setComponent(
              <DeleteAddress
                id={itemInfo.id}
                setIsOpenDrawer={setIsOpenDrawer}
                title={titleData}
                updateAddress={updateAddress}
              />
            );
          }}
        >
          <span className="title-h4-m"> حذف این آدرس</span>
        </CustomButton>
        <CustomButton
          className="w-50"
          buttonStyle="primary"
          state="default"
          size="medium"
          onClick={() => {
            let error = valid();
            if (error[0] && error[1] && error[2]) {
              EditAddressFunc(
                address + "&" + addressData,
                titleData,
                mobileData
              );
            }
          }}
        >
          <span className="title-h4-m ">ویرایش</span>
        </CustomButton>
      </div>
    </>
  );
};
